import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useBuilderRunNowResultsLogic } from 'shared-modules/services/hooks/builder';
import { handleRedirect } from '../../../../redux/actions';
import RunSuccess from '../RunAutoTradeComponents/RunSuccess';

const TradeAPAddToPortfolioSuccess = ({ isOpen, closeModal, orderName }) => {
  const dispatch = useDispatch();

  const openHomeScreen = useCallback(() => {
    closeModal();
    dispatch(handleRedirect({ url: '/home', isInner: true }));
  }, [closeModal, dispatch]);

  const runNowResultsLogic = useBuilderRunNowResultsLogic({ orderName, closeModal });

  return (
    <RunSuccess
      isOpen={isOpen}
      closeModal={closeModal}
      runNowResultsLogic={runNowResultsLogic}
      onClickButton={openHomeScreen}
    />
  );
};

TradeAPAddToPortfolioSuccess.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  orderName: PropTypes.string.isRequired,
};

export default memo(TradeAPAddToPortfolioSuccess);
